export const COLLECTION_NAV_LINK = {
    destination: '/collection/tasks',
    label: 'Collection',
    activePrefixes: ['/collection'],
};
